import './overview.scss';

import React, { useEffect, useState } from 'react';
import { Line } from 'react-chartjs-2';

import { fetchCurrencies } from '../../../api';
import { fetchCurrencyGraph } from '../../../api';
import { CHART_CONFIG, CHART_OPTIONS } from '../../../config';
import { capitalize } from '../../../utils/formatters';
import { Dropdown } from '../../dropdown';

const TransactionOverview = () => {
  const [currencies, setCurrencies] = useState([]);
  const [selectedCurrency, setSelectedCurrency] = useState();
  const [filter, setFilter] = useState();
  const [filters, setFilters] = useState();
  const [chart, setChart] = useState();

  const data = (chartData) => {
    return {
      labels: filter && chartData ? chartData[filter].labels : [],
      datasets: [
        {
          data: filter && chartData ? chartData[filter].data : [],
          ...CHART_CONFIG
        }
      ]
    };
  };

  useEffect(async () => {
    const allCurrencies = await fetchCurrencies();
    const formattedCurrencies = [];
    allCurrencies.forEach((currency) => {
      formattedCurrencies.push({
        label: currency.slug,
        value: currency.value
      });
    });
    const lastCurrency = formattedCurrencies[formattedCurrencies.length - 1]?.value;
    setSelectedCurrency(lastCurrency);
    setCurrencies([...formattedCurrencies]);
  }, []);

  useEffect(async () => {
    if (currencies.length > 0 && selectedCurrency) {
      const currencyGraph = await fetchCurrencyGraph(selectedCurrency);
      const transactionFilters = [];
      Object.keys(currencyGraph).forEach((filter) => {
        transactionFilters.push({
          label: capitalize(filter),
          value: filter
        });
      });

      setFilter(filter || transactionFilters[transactionFilters.length - 1].value);
      setFilters(filters || transactionFilters);
      setChart(data(currencyGraph));
    }
  }, [currencies, selectedCurrency, filter]);

  const updateFilter = {
    onChange: (e) => setFilter(e.target.value)
  };

  const updateCurrency = {
    onChange: (e) => setSelectedCurrency(e.target.value)
  };
  return (
    <div className="card transaction-overview">
      <div className="card__header">
        <h3 className="card__title">
          Transaction <span className="text-cursive">overview</span>
        </h3>
        <div className="transaction-overview__filters">
          {currencies && selectedCurrency && (
            <Dropdown
              placeholder="Currency"
              name="currency"
              options={currencies}
              defaultValue={selectedCurrency}
              register={updateCurrency}
              disabled
            />
          )}
          {filters && filter && (
            <Dropdown
              placeholder="Filter"
              name="filter"
              options={filters}
              defaultValue={filters[filters.length - 1]?.value}
              register={updateFilter}
              disabled
            />
          )}
        </div>
      </div>
      <div className="transaction-overview__chart">
        <div className="transaction-overview__chart--desktop">
          {chart && <Line data={chart} options={{ ...CHART_OPTIONS, aspectRatio: 2.7 }} />}
        </div>
        <div className="transaction-overview__chart--mobile">
          {chart && <Line data={chart} options={{ ...CHART_OPTIONS, aspectRatio: 1.1 }} />}
        </div>
      </div>
    </div>
  );
};

export { TransactionOverview };
